import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import '@vaadin/vaadin-accordion/vaadin-accordion';
let FulfillmentHistory = class FulfillmentHistory extends RxElement {
    constructor() {
        super(...arguments);
        this.topics = [];
        this.subTopics = [];
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        this.topics = this.topics.filter(Boolean);
        if (this.fulfillment) {
            this.details = {
                created: this.fulfillment.salesforceCase.createdDate,
                topic1: this.fulfillment.salesforceCase.topics_1__c,
                subTopic1: this.fulfillment.salesforceCase.sub_Topics_1__c,
                subject: this.fulfillment.salesforceCase.subject,
                description: this.fulfillment.salesforceCase.description,
                status: this.fulfillment.salesforceCase.status,
            };
        }
        if (this.globalFulfillment) {
            this.details = {
                created: this.globalFulfillment.createdOn,
                subject: this.globalFulfillment.subject,
                description: this.globalFulfillment.description,
                status: this.status,
                topics: this.topics,
                subTopics: this.subTopics,
            };
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('adviseeName')) {
            this.requestUpdate();
        }
    }
    render() {
        const createdDate = new Date(this.details.created);
        const dateString = createdDate.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        });
        const timeString = createdDate.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: '2-digit',
            timeZoneName: 'short',
        });
        return html `<div class="tab__content">
      ${!this.details
            ? html `No History Found`
            : html `<vaadin-accordion>
            <vaadin-accordion-panel theme="reverse">
              <div slot="summary" class="summary">
                <strong>${this.adviseeName}</strong> connected with
                <strong>${this.coachName}</strong> on
                <strong>${`${dateString} at ${timeString}`}</strong>
              </div>
              <vaadin-vertical-layout>
                <table>
                  ${this.details.topics &&
                this.details.topics.length &&
                html `${this.topics.map((t, i) => {
                    if (t && this.details.subTopics[i]) {
                        return html `<tr>
                          <td class="history__detail">Topic:</td>
                          <td>${t}</td>
                        </tr>
                        <tr>
                          <td class="history__detail">Sub Topic:</td>
                          <td>${this.details.subTopics[i]}</td>
                        </tr>`;
                    }
                    if (t) {
                        return html `<tr>
                        <td class="history__detail">Topic:</td>
                        <td>${t}</td>
                      </tr>`;
                    }
                    return null;
                })}`}
                  ${this.details.topic1 &&
                html `
                    <tr>
                      <td class="history__detail">Topic:</td>
                      <td>${this.details.topic1}</td>
                    </tr>
                  `}
                  ${this.details.subTopic1 &&
                html `
                    <tr>
                      <td class="history__detail">Subtopic:</td>
                      <td>${this.details.subTopic1}</td>
                    </tr>
                  `}
                  <tr>
                    <td class="history__detail">Subject:</td>
                    <td>${this.details.subject}</td>
                  </tr>
                  <tr>
                    <td class="history__detail">Description:</td>
                    <td>${this.details.description}</td>
                  </tr>
                  <tr>
                    <td class="history__detail">Status:</td>
                    <td>${this.details.status}</td>
                  </tr>
                </table>
              </vaadin-vertical-layout>
            </vaadin-accordion-panel>
          </vaadin-accordion>`}
    </div>`;
    }
};
FulfillmentHistory.styles = css `
    :host {
      width: 100%;
    }
    .tab__content {
      padding: 20px;
    }
    .summary {
      font-size: 14px;
      color: #000;
      font-weight: 400;
    }
    table {
      width: 100%;
      font-size: 13px;
    }
    vaadin-accordion-panel {
      background: #fff;
      border: 2px solid #f7f7fa;
      margin-bottom: 10px;
      padding: 10px 15px;
      border-radius: 8px;
    }
    vaadin-accordion-panel[opened] {
      background: #f7f7fa !important;
      border: 2px solid #f7f7fa;
    }
    .history__detail {
      font-weight: 500;
      width: 100px;
      vertical-align: top;
    }
  `;
__decorate([
    property()
], FulfillmentHistory.prototype, "case", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "coachName", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "adviseeName", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "fulfillment", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "globalFulfillment", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "details", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "topics", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "subTopics", void 0);
__decorate([
    property()
], FulfillmentHistory.prototype, "status", void 0);
__decorate([
    state()
], FulfillmentHistory.prototype, "history", void 0);
FulfillmentHistory = __decorate([
    customElement('fulfillment-history')
], FulfillmentHistory);
export { FulfillmentHistory };
//# sourceMappingURL=history.js.map